import React from "react";
import Fab from "@mui/material/Fab";
import PhoneIcon from "@mui/icons-material/Phone";
import { Grid, Grid2 } from "@mui/material";
import theme from "../theme";
import ShareIcon from "@mui/icons-material/Share";
import PlaceIcon from "@mui/icons-material/Place";

const RoundedButtons = ({
  agentPhoneNumber,
  waze,
  uid,
  propertyId,
  propertySecureNum,
}) => {
  const handleShare = async (e) => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Real Estate Property",
          text: "Please Take A Look At This Property",
          url: `https://greenbook.co.il/re/${propertySecureNum}/${propertyId}/${uid}`,
        });
        e.stopPropagation();
        // console.log("Shared successfully");
      } else {
        throw new Error("Web Share API not supported");
      }
    } catch (error) {
      console.error("Error sharing:", error);
    }
  };
  // console.log(
  //   "propertyId and propertySecureNum in rounded buttons",
  //   propertyId,
  //   propertySecureNum
  // );

  return (
    <Grid2
      container
      justifyContent="flex-end"
      alignItems="center"
      spacing={0.5}
      // sx={{
      //   pr: "30px",
      //   pb: "15px",
      //   position: "absolute",
      //   top: "42%",
      //   left: "80%",
      //   transform: "translate(-50%, -50%)",
      //   zIndex: 2,
      //   width: "43%",

      //   "@media (max-width: 700px)": {
      //     left: "70%",
      //     top: "42%",
      //     width: "50%",
      //   },
      //   "@media (max-width: 1000px)": {
      //     left: "80%",
      //     top: "42%", // change for mobile phone rounded button not in place
      //     width: "50%",
      //   },
      // }}
    >
      <Grid2 item>
        <Fab
          size="small"
          component="a"
          href={`tel:${agentPhoneNumber}`}
          sx={{
            backgroundColor: "white",
            color: theme.palette.primary.main,
            marginRight: 1,
          }}
          onClick={() => `tel:${agentPhoneNumber}`}
        >
          <PhoneIcon />
        </Fab>
      </Grid2>
      <Grid2 item>
        {waze !== "" && (
          <Fab
            size="small"
            component="a"
            href={waze}
            sx={{
              backgroundColor: "white",
              color: theme.palette.primary.main,
              marginRight: 1,
            }}
          >
            <PlaceIcon />
          </Fab>
        )}
      </Grid2>
      <Grid2 item>
        <Fab
          size="small"
          sx={{ backgroundColor: "white", color: theme.palette.primary.main }}
          onClick={handleShare}
        >
          <ShareIcon />
        </Fab>
      </Grid2>
    </Grid2>
  );
};

export default RoundedButtons;
